export default __webpack_public_path__ + "static/media/3.3e00f4b0.webp";